import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import requestOrganizationById from './graphql';

export default function SearchUsersHOC(ViewUsersPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        jwtToken: PropTypes.string.isRequired,
        expiration: PropTypes.number.isRequired,
        organizationId: PropTypes.string.isRequired,
        role: PropTypes.string.isRequired,
      }).isRequired,
      superAdminView: PropTypes.bool.isRequired,
      cage: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      users: PropTypes.array.isRequired,
      refreshUsers: PropTypes.func.isRequired,
      loading: PropTypes.bool.isRequired,
      organizationsStatus: PropTypes.string.isRequired,
      organizationsName: PropTypes.string.isRequired,
      organizationsCage: PropTypes.string.isRequired,
    };

    static initialState = {
      errors: [],
      isLoading: false,
    };

    state = WrappedComponent.initialState;

    render() {
      const { isLoading } = this.state;
      const {
        auth,
        users,
        refreshUsers,
        loading,
        organizationsStatus,
        organizationsName,
        organizationsCage,
      } = this.props;
      const pageProps = {
        organizationsStatus,
        refreshUsers,
        loading,
        organizationsName,
        organizationsCage,
        auth,
        users,
        isLoading,
        viewNewUserForm: this.state.viewNewUserForm,
      };
      return <ViewUsersPage {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/SuperAdminHome/SearchUsers/SearchUsersHOC.jsx